export const GET_HRMS_INTEGRATION_KNIT_QUERY_KEY = 'GET_HRMS_INTEGRATION_KNIT_QUERY_KEY';

export const GET_HRMS_EMPLOYEE_TYPES_QUERY_KEY = 'GET_HRMS_EMPLOYEE_TYPES_QUERY_KEY';

export const GET_HRMS_ENTITY_TYPES_QUERY_KEY = 'GET_HRMS_ENTITY_TYPES_QUERY_KEY';

export const KNIT_HRMS_QUERY_RETRY_LIMIT = 3;
